/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import { createRouterSelector } from '@atlassian/react-resource-router';
// eslint-disable-next-line jira/restricted/fedramp-isolated-cloud
import { isIsolatedCloud } from '@atlassian/atl-context';
import { fg } from '@atlassian/jira-feature-gating';

// oxlint-disable-next-line typescript/no-invalid-void-type
export const useUrl: (args_0: void) => string = createRouterSelector(({ match }) => match.url);

export const useHideAssetsReportsInIsolatedCloud = (): boolean => {
	const url = useUrl();
	const isIsolatedCloudEnv = fg('aem_migration_jira')
		? !isFeatureEnabled('assets', 'assets-reports')
		: isIsolatedCloud();
	const isReportsUrl = url.startsWith('/jira/assets/reports');

	if (isReportsUrl && isIsolatedCloudEnv) {
		return true;
	}

	return false;
};
